var map = {
	"./de.json": 549786,
	"./en.json": 2665,
	"./es.json": 527822,
	"./fr.json": 324231,
	"./it.json": 455578,
	"./ja.json": 612478,
	"./ko.json": 897913,
	"./pl.json": 634029,
	"./pt.json": 400470,
	"./ru.json": 184855,
	"./uk.json": 756242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 683911;